import {
  BranchDeliverySystemsService,
  type BranchDeliverySystemAdminDto,
  type PostPutBranchDeliverySystemRequestAdmin
} from '@/backend/market'
import { BranchDeliverySettingRepository } from '../../domain/repositories/BranchDeliverySettingRepository'
import { BranchDeliverySettingModel } from '../models/BranchDeliverySettingModel'
import type { BranchDeliverySettingEntity } from '../../domain/entities/BranchDeliverySettingEntity'
import { UpdateBranchDeliverySettingModel } from '../models/UpdateBranchDeliverySettingModel'
import type { BranchDeliverySettingFilterEntity } from '../../domain/entities/BranchDeliverySettingFilterEntity'
import { BranchDeliverySettingFilterModel } from '../models/BranchDeliverySettingFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import { BranchDeliverySettingMiniModel } from '../models/BranchDeliverySettingMiniModel'
import type { BranchDeliverySettingMiniEntity } from '../../domain/entities/BranchDeliverySettingMiniEntity'
export class BranchDeliverySettingRepositoryImpl implements BranchDeliverySettingRepository {
  async getBranchDeliverySettings(
    filterData: BranchDeliverySettingFilterEntity
  ): Promise<PaginateEntity<BranchDeliverySettingMiniEntity[]> | { error: true }> {
    const filterModel = new BranchDeliverySettingFilterModel(filterData)
    try {
      const response = await BranchDeliverySystemsService.getBranchDeliverySystemAdmin(
        filterModel as {}
      )
      const branchDeliverySettingMiniModels = response.items?.map(
        (item) => new BranchDeliverySettingMiniModel(item as BranchDeliverySettingMiniEntity)
      )
      const branchDeliverySettingResponse = new PaginateEntity<BranchDeliverySettingMiniModel[]>(
        response,
        branchDeliverySettingMiniModels
      )
      return branchDeliverySettingResponse
    } catch {
      return { error: true }
    }
  }
  async getBranchDeliverySetting(
    branchDeliverySystemId: number
  ): Promise<BranchDeliverySettingEntity | { error: true }> {
    try {
      const response = await BranchDeliverySystemsService.getBranchDeliverySystemAdmin1({
        branchDeliverySystemId
      })
      const branchDeliverySettingModel = new BranchDeliverySettingModel(
        response as BranchDeliverySystemAdminDto
      )

      return branchDeliverySettingModel
    } catch {
      return { error: true }
    }
  }
  async createBranchDeliverySetting(
    branchDeliverySetting: BranchDeliverySettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const branchDeliverySettingModel = new UpdateBranchDeliverySettingModel(branchDeliverySetting)
    try {
      await BranchDeliverySystemsService.postBranchDeliverySystemAdmin({
        requestBody:
          branchDeliverySettingModel as unknown as PostPutBranchDeliverySystemRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateBranchDeliverySetting(
    branchDeliverySystemId: number,
    branchDeliverySetting: BranchDeliverySettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const branchDeliverySettingModel = new UpdateBranchDeliverySettingModel(branchDeliverySetting)
    try {
      await BranchDeliverySystemsService.putBranchDeliverySystemAdmin({
        branchDeliverySystemId,
        requestBody:
          branchDeliverySettingModel as unknown as PostPutBranchDeliverySystemRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteBranchDeliverySetting(
    branchDeliverySystemId: number
  ): Promise<{ success: true } | { error: true }> {
    try {
      await BranchDeliverySystemsService.deleteBranchDeliverySystemAdmin({
        branchDeliverySystemId
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
